// @ts-nocheck
import React from "react";
import { compose } from "modules/core";
import { withApollo } from '@apollo/client/react/hoc';
import { READINESS_MODULE_USAGE } from "modules/poc-dashboard/graphql/moduleusageQuery.gql";
import CommonTableView from "modules/poc-dashboard/components/common/tableView";
import { Capitalize, displayUtcToUserTimezone } from "modules/look";
import moment from "moment-timezone";
import { getOrgID } from "../../organization/organizationOperations";


const ReadinessModuleUsageContainer = (props) => {
    const { client, permission, date_range_filter, search, orgToFetchData } = props
    const [data_list_loading, setDataListLoading] = React.useState(false)
    const [list, SetList] = React.useState([])
    const [page_info, SetPageInfo] = React.useState()
    const list_ref = React.useRef([])

    React.useEffect(() => {
        list_ref.current = list
    }, [list])

    const header_list = [
        {
            label: "Employee Name"
        },
        {
            label: "Self Assessments"
        },
        {
            label: "Received Assessments"
        },
        {
            label: "Last Accessed Date"
        }
    ]
    React.useEffect(() => {
        if (permission?.required_permission && (orgToFetchData?.id || getOrgID(props))) {
            ModuleUsage({})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permission, orgToFetchData])

    React.useEffect(() => {
        ModuleUsage({})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [date_range_filter])

    const timeout_ref = React.useRef()

    React.useEffect(() => {
        clearTimeout(timeout_ref.current)
        timeout_ref.current = setTimeout(() => {
            ModuleUsage({})
        }, 600)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search])

    const readiness_filter = React.useRef({})
    const onDataFetch = (data) => {
        let list = data?.map(({ user, readinessGiven, lastGivenDate, readinessReceived, lastReceivedDate }) => {
            let row_data = user ? [
                {
                    type: "label",
                    value: `${Capitalize(user?.firstName)} ${Capitalize(user?.lastName) || ""}`
                },
                {
                    type: "label",
                    value: readinessGiven?.edges?.filter(({ node }) => node?.readinessTo?.id === node?.readinessFrom?.id).length
                },
                {
                    type: "label",
                    value: readinessReceived?.edges?.filter(({ node }) => node?.readinessTo?.id !== node?.readinessFrom?.id).length
                },
                {
                    type: "label",
                    value: (() => {
                        if (!lastGivenDate?.edges?.length && !lastReceivedDate?.edges?.length) {
                            return "-"
                        }
                        if (lastGivenDate?.edges?.length && lastReceivedDate?.edges?.length) {
                            return moment(lastGivenDate?.edges?.[0]?.node?.updatedAt).isAfter(moment(lastReceivedDate?.edges?.[0]?.node?.updatedAt))
                                ? displayUtcToUserTimezone(moment(lastGivenDate?.edges?.[0]?.node?.updatedAt), 'DD/MM/YYYY')
                                : displayUtcToUserTimezone(moment(lastReceivedDate?.edges?.[0]?.node?.updatedAt), 'DD/MM/YYYY')
                        }
                        return displayUtcToUserTimezone(moment(lastGivenDate?.edges?.[0]?.node?.updatedAt || lastReceivedDate?.edges?.[0]?.node?.updatedAt), 'DD/MM/YYYY')
                    })()
                }
            ] : []
            return row_data
        })
        if (readiness_filter?.current?.after) {
            list = list_ref?.current?.concat(list)
        }

        SetList(list?.filter(i => i?.length))
        setDataListLoading(false)
    }

    const ModuleUsage = async (filter) => {
        try {
            setDataListLoading(true)
            const { data } = await client.query({
                query: READINESS_MODULE_USAGE,
                variables: { ...filter, first: 10, user_FirstName: search, id: getOrgID(props) || orgToFetchData?.id },
                fetchPolicy: 'network-only'
            });
            if (data?.organizationById?.employees?.edges?.length) {
                readiness_filter.current = filter
                onDataFetch(data?.organizationById?.employees?.edges.map(edge => edge?.node))
                SetPageInfo(data?.organizationById?.employees?.pageInfo)
            }
        } catch (error) {
            console.error("ReadinessModuleUsageContainer -> ModuleUsage", error)
            setDataListLoading(false)
        }
    }

    const onPagination = () => {
        if (page_info?.hasNextPage) {
            ModuleUsage({ after: page_info?.endCursor })
        }
    }

    return (
        <>
            <CommonTableView {...props} data_list_loading={data_list_loading} header_list={header_list} list={list} page_info={page_info} onPagination={onPagination} />
        </>
    )
}

export default compose(withApollo)(ReadinessModuleUsageContainer)